import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { CustomCostCenterComponent } from './custom-cost-center.component'

@NgModule({
  declarations: [CustomCostCenterComponent],
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutCostCenterComponent: {
          component: CustomCostCenterComponent,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard]
        }
      }
    })
  ]
})
export class CustomCostCenterModule {}
